/* eslint-disable no-nested-ternary */
import React from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { IPreviousAppointment } from '../../../PreviousAppointments/IPreviousAppointment'
import { customerPortalLinks } from '../../../App/Util/customerPortalUrl'
import {
  AlreadyBookedAppointmentsNoticeText,
  AlreadyBookedAppointmentsNoticeView,
} from './style'

export const AlreadyBookedAppointmentsNotice = ({
  date,
  previousAppointments,
  establishmentId,
}: {
  date: string
  previousAppointments: IPreviousAppointment[]
  establishmentId: string
}) => {
  const { t } = useTranslation()
  return (
    <AlreadyBookedAppointmentsNoticeView>
      <AlreadyBookedAppointmentsNoticeText>
        <p>
          {t('You already have a booking with us on ')}
          {moment(date).format('DD/MM/YYYY')}
          {t(' at ')}
          {previousAppointments.map((appointment, index) => (
            <span key={appointment.id}>
              {moment(appointment.date).format('HH:mm')}
              {previousAppointments.length - 1 !== index
                ? index === previousAppointments.length - 2
                  ? ' & '
                  : ', '
                : ''}
            </span>
          ))}
          .
        </p>

        <a href={customerPortalLinks.appointments(establishmentId)}>
          {t('Manage your bookings')}
        </a>
      </AlreadyBookedAppointmentsNoticeText>
    </AlreadyBookedAppointmentsNoticeView>
  )
}
